import { z } from "zod";

const getCompanyOnboardingTaskFieldsResponseSchema = z.object({
  company_onboarding_task_fields: z.record(z.string()),
  onboarding_url: z.string().optional(),
});

export type TGetCompanyOnboardingTaskFieldsResponse = z.infer<
  typeof getCompanyOnboardingTaskFieldsResponseSchema
>;
